import cardiovascularIcon from "../../../icons/pmr/study/cardiovascular.svg";
import dermatologyIcon from "../../../icons/pmr/study/dermatology.svg";
import endocrinologyIcon from "../../../icons/pmr/study/endocrinology.svg";
import gynaecologyIcon from "../../../icons/pmr/study/gynac.svg";
import hematologyIcon from "../../../icons/pmr/study/hematology.svg";
import immunologyIcon from "../../../icons/pmr/study/immunology.svg";
import infectiousDiseaseIcon from "../../../icons/pmr/study/infectious-disease.svg";
import inflamatoryIcon from "../../../icons/pmr/study/inflammatory_disease.svg";
import metabolismIcon from "../../../icons/pmr/study/metabolism.svg";
import nephrologyIcon from "../../../icons/pmr/study/nephrology.svg";
import neuroscienceIcon from "../../../icons/pmr/study/neuroscience.svg";
import notApplicableIcon from "../../../icons/pmr/study/not_applicable.svg";
import oncogenomicsIcon from "../../../icons/pmr/study/oncogenomics.svg";
import oncologyIcon from "../../../icons/pmr/study/oncology.svg";
import ophthalmologyIcon from "../../../icons/pmr/study/ophthalmology.svg";
import rareDiseaseIcon from "../../../icons/pmr/study/rare_disease.svg";
import respiratoryDiseaseIcon from "../../../icons/pmr/study/respiratory_disease.svg";
import spineIcon from "../../../icons/pmr/study/spine.svg";
import { TStudyIconProps } from "../models";

const iconMap: Record<string, string> = {
  Cardiovascular: cardiovascularIcon,
  "Inflammatory Disease": inflamatoryIcon,
  Dermatology: dermatologyIcon,
  Endocrinology: endocrinologyIcon,
  Gynaecology: gynaecologyIcon,
  Hematology: hematologyIcon,
  Immunology: immunologyIcon,
  "Infectious Disease": infectiousDiseaseIcon,
  Metabolism: metabolismIcon,
  "Musculoskeletal disorder": spineIcon,
  Nephrology: nephrologyIcon,
  Neuroscience: neuroscienceIcon,
  Oncology: oncologyIcon,
  Ophthalmology: ophthalmologyIcon,
  "Respiratory Disease": respiratoryDiseaseIcon,
  "Rare Disease": rareDiseaseIcon,
  Oncogenomics: oncogenomicsIcon,
  "Not Applicable": notApplicableIcon,
};

export const StudyIcon = ({ therapeuticArea, size = 50, fallbackSrc = cardiovascularIcon }: TStudyIconProps) => {
  const icon_key = Object.keys(iconMap).find((iconKey) => iconKey == therapeuticArea);

  const src = icon_key ? iconMap[icon_key] : fallbackSrc;

  return <img src={src} width={size} height={size} alt={`${therapeuticArea} icon`} style={{ flexShrink: 0 }} />;
};
